/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ButtonReadOnly.vue?vue&type=template&id=6b97feb6"
import script from "./ButtonReadOnly.ts?vue&type=script&lang=ts&external"
export * from "./ButtonReadOnly.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports